import { useMemo } from "react";
import { useAppSelector } from "../store/hooks";

/**
 * Custom hook to determine which dataset to use depending on selected tab.
 * @returns {GanttChartData} dataToUse
 */
const useDataSelector = () => {
  // Listen to the selectedGanttChartTab from Redux store
  const { selectedGanttChartTab, ganttChartData } = useAppSelector((state) => state.ganttChartSlice);
  const { customGanttChartData } = useAppSelector((state) => state.dragAndDropSlice);

  // Use useMemo to prevent unnecessary recalculations and re-renders
  const dataToUse = useMemo(() => {
    if (selectedGanttChartTab === "Custom") {
      // If custom data is available, use it; otherwise fall back to regular data
      return customGanttChartData || ganttChartData;
    }

    return ganttChartData;
  }, [selectedGanttChartTab, ganttChartData, customGanttChartData]);

  return dataToUse;
};

export default useDataSelector;